import axios from 'axios';

const url = process.env.REACT_APP_RESTAPI;
const urlV3 = process.env.REACT_APP_RESTAPI_V3;

// For loading animation purposes
const delay = (ms) => new Promise((resolve) => (setTimeout(resolve, ms)));

export const APIGetPayload = async (setLoading, token, agencyId, pairId) => {
    setLoading(true);
    const result = await axios.get(`${url}/payload`, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
        params: {
            pairId: pairId,
        },
    }).catch((error) => error);
    return result;
};

export const APIGetSearchAssetnAssetGroup = async (token, setLoading, agencyId, searchType, searchKey, selectedIds) => {
    setLoading(true);
    const result = await axios.get(`${url}/searchAssetsnGroups`, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
        params: {
            searchType: searchType,
            searchKey: searchKey,
            selectedIds: selectedIds,
        },
    }).catch((error) => error);
    return result;
};

export const APISendTeltonikaCommand = async (commandData, token, agencyId, setLoading) => {
    setLoading(true);
    const result = await axios.post(`${url}/teltonikaCommand`, commandData, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
    }).catch((error) => error.response.status);
    return result;
};

export const APIGetCountries = async (setLoading) => {
    setLoading(true);
    const result = await axios.get('https://valid.layercode.workers.dev/list/countries?format=select&flags=true&value=code').catch((error) => error);
    return result;
};

export const APIGetDevices = async (setLoading, token, agencyId, params) => {
    setLoading(true);
    const result = await axios.get(`${urlV3}/devices`, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
        params: params,
    }).catch((error) => error.response.status);
    return result;
};

export const APIGetV3Payload = async (setLoading, token, agencyId, pairId) => {
    setLoading(true);
    const result = await axios.get(`${urlV3}/payload`, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
        params: {
            deviceOid: pairId,
        },
    }).catch((error) => error);
    return result;
};

export const APIGetV3TelemetryLog = async (setLoading, token, agencyId, fromTime, toTime, deviceOid, fuelSource, mileageSource) => {
    setLoading(true);
    const result = await axios.get(`${urlV3}/telemetryLogReport`, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
        params: {
            fromTime: fromTime,
            toTime: toTime,
            deviceOid: deviceOid,
            fuelSource: fuelSource,
            mileageSource: mileageSource,
        },
    }).catch((error) => error?.response || error);
    return result;
};

export const APICreateTelemetryLogZipJob = async (token, agencyId, payload) => {
    const result = await axios.post(`${urlV3}/telemetryLogReportZipJobs`, payload, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
    }).catch((error) => error);
    return result;
};

export const APIGetTelemetryLogZipJobStatus = async (token, agencyId, jobId) => {
    const result = await axios.get(`${urlV3}/telemetryLogReportZipJobs/${jobId}`, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
    }).catch((error) => error);
    return result;
};

export const APIGetV3TeamMembers = async (setLoading, token, agencyId, params) => {
    setLoading(true);
    const result = await axios.get(`${urlV3}/team`, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
        params: params,
    }).catch((error) => error);
    return result;
};

export const APIGetUsers = async (setLoading, token, agencyId) => {
    setLoading(true);
    const result = await axios.get(`${urlV3}/account`, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
    }).catch((error) => error);
    return result;
};

export const APIGetAgencies = async (setLoading, token, agencyId, params) => {
    setLoading(true);
    const result = await axios.get(`${urlV3}/agencies`, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
        params: params,
    }).catch((error) => error);
    await delay(500);
    return result;
};

export const APIGetGeofence = async (setLoading, token, agencyId, params) => {
    setLoading(true);
    const result = await axios.get(`${urlV3}/geofences`, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
        params: params,
    }).catch((error) => error);
    return result;
};

export const APIGetAssetUtilisation = async (setLoading, token, agencyId, params) => {
    setLoading(true);
    const result = await axios.get(`${urlV3}/assetUtilisation`, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
        timeout: 120000,
        params: params,
    }).catch((error) => error);
    return result;
};

export const APIGetAssetUtilisationPerc = async (setLoading, token, agencyId, params) => {
    setLoading(true);
    const result = await axios.get(`${urlV3}/assetUtilisationPerc`, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
        timeout: 120000,
        params: params,
    }).catch((error) => error);
    return result;
};

export const APIGetTotalIngestedPayloads = async (setLoading, token, agencyId, params) => {
    setLoading(true);
    const result = await axios.get(`${urlV3}/ingestedPayloads`, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
        // timeout: 12000,
        params: params,
    }).catch((error) => error);
    return result;
};

export const APIGetTotalDevices = async (setLoading, token, agencyId, params) => {
    setLoading(true);
    const result = await axios.get(`${urlV3}/totalDevices`, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
        timeout: 120000,
        params: params,
    }).catch((error) => error);
    return result;
};

export const APIGetActiveDevicePerc = async (setLoading, token, agencyId, params) => {
    setLoading(true);
    const result = await axios.get(`${urlV3}/activeDevicesPercentage`, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
        // timeout: 12000,
        params: params,
    }).catch((error) => error);
    return result;
};

export const APIGetTripReport = async (setLoading, token, agencyId, fromTime, toTime, deviceOid) => {
    setLoading(true);
    const result = await axios.get(`${urlV3}/trip`, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
        params: {
            fromTime: fromTime,
            toTime: toTime,
            deviceOid: deviceOid,
        },
    }).catch((error) => error);
    return result;
};

export const APIGetSIMDetails = async (setLoading, token, agencyId, params) => {
    setLoading(true);
    const result = await axios.get(`${urlV3}/sims`, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
        params: params,
    }).catch((error) => error);
    return result;
};

export const APIGetAlerts = async (setLoading, token, agencyId, params) => {
    setLoading(true);
    const result = await axios.get(`${urlV3}/alerts`, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
        params: params,
    }).catch((error) => error);
    return result;
};

export const APIGetAlertPolicies = async (setLoading, token, agencyId, params) => {
    setLoading(true);
    const result = await axios.get(`${urlV3}/alertPolicies`, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
        params: params,
    }).catch((error) => error);
    return result;
};

/** GET automated report configurations for the agency (query: agencyOid). */
export const APIGetAutomateReports = async (token, agencyId, params = {}) => {
    const result = await axios.get(`${urlV3}/automateReport`, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
        params: {
            agencyOid: agencyId,
            ...params,
        },
    }).catch((error) => error);
    return result;
};

export const APIGetAutomateReportById = async (token, agencyId, id) => {
    const result = await axios.get(`${urlV3}/automateReport/${encodeURIComponent(id)}`, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
    }).catch((error) => error);
    return result;
};

export const APIPostAutomateReport = async (token, agencyId, body) => {
    const result = await axios.post(`${urlV3}/automateReport`, body, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
            'Content-Type': 'application/json',
        },
    }).catch((error) => error);
    return result;
};

export const APIPatchAutomateReport = async (token, agencyId, id, body) => {
    const result = await axios.patch(`${urlV3}/automateReport/${encodeURIComponent(id)}`, body, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
            'Content-Type': 'application/json',
        },
    }).catch((error) => error);
    return result;
};

export const APIDeleteAutomateReport = async (token, agencyId, id) => {
    const result = await axios.delete(`${urlV3}/automateReport/${encodeURIComponent(id)}`, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
    }).catch((error) => error);
    return result;
};

export const APIGetBatteryPolicies = async (setLoading, token, agencyId, params) => {
    setLoading(true);
    const result = await axios.get(`${urlV3}/batteryPolicies`, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
        params: params,
    }).catch((error) => error.response.status);
    return result;
};

export const APIGetFuelPolicies = async (setLoading, token, agencyId, params) => {
    setLoading(true);
    const result = await axios.get(`${urlV3}/fuelPolicies`, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
        params: params,
    }).catch((error) => error.response?.status ?? error);
    return result;
};

// Vehicle types available for vehicle presets. Readable by any authenticated user; pass
// { includeInactive: true } as a System Administrator to also get deactivated types.
export const APIGetVehicleTypes = async (token, agencyId, params) => {
    const result = await axios.get(`${urlV3}/vehicleTypes`, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
        params: params,
    }).catch((error) => error);
    return result;
};

export const APIGetVehicleAdminPresets = async (setLoading, token, agencyId, params) => {
    setLoading(true);
    const result = await axios.get(`${urlV3}/vehicleAdminPresets`, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
        params: params,
    }).catch((error) => error);
    return result;
};

const buildFuelPriceHeaders = (token, agencyId) => {
    const headers = {};
    if (token) headers.Authorization = token;
    if (agencyId) headers['agency-id'] = agencyId;
    return headers;
};

// 401: clear session and redirect to /login.
// 502: retried once at the call site (upstream provider hiccup).
// Any other error is re-thrown so SWR can surface it to the UI.
const handleFuelPriceFailure = (error) => {
    const status = error?.response?.status;
    if (status === 401) {
        if (typeof window !== 'undefined') {
            window.location.assign('/login');
        }
    }
    throw error;
};

const requestFuelPricesOnce = async ({ token, agencyId, params }) => {
    const response = await axios.get(`${urlV3}/fuelPrices`, {
        headers: buildFuelPriceHeaders(token, agencyId),
        params,
    });
    return response.data;
};

const requestFuelPricesWithRetry = async ({ token, agencyId, params }) => {
    try {
        return await requestFuelPricesOnce({ token, agencyId, params });
    } catch (error) {
        if (error?.response?.status === 502) {
            try {
                return await requestFuelPricesOnce({ token, agencyId, params });
            } catch (retryError) {
                return handleFuelPriceFailure(retryError);
            }
        }
        return handleFuelPriceFailure(error);
    }
};

// Canonical current snapshot: GET /v3/fuelPrices?current=true
export const APIGetCurrentFuelPrices = (token, agencyId) => requestFuelPricesWithRetry({
    token,
    agencyId,
    params: { current: true },
});

// Canonical history query: GET /v3/fuelPrices?fuelType=X&date_start=...&date_end=...&sort=-effectiveFrom&limit=500
//
// All filters are optional, and the date bounds apply to `effectiveFrom`. Two
// distinct questions, so pick deliberately:
//   - "which prices CHANGED in this range?" → pass dateStart + dateEnd (Price Registry).
//   - "which price was IN FORCE at some past moment?" → pass dateEnd only, so the
//     interval that opened before the range is still returned (Fuel Level Signal).
// `limit` truncates one -effectiveFrom ordering shared by every grade unless
// `fuelType` is also given, so an unfiltered caller needs it high enough to reach
// past the oldest still-open interval.
export const APIGetFuelPriceHistory = (token, agencyId, {
    fuelType,
    dateStart,
    dateEnd,
    limit = 500,
    sort = '-effectiveFrom',
} = {}) => {
    const params = { sort, limit };
    if (fuelType) params.fuelType = fuelType;
    if (dateStart) params.date_start = dateStart;
    if (dateEnd) params.date_end = dateEnd;
    return requestFuelPricesWithRetry({ token, agencyId, params });
};

const buildV3AuthHeaders = (token, agencyId, withJson = false) => {
    const headers = {};
    if (token) headers.Authorization = token;
    if (agencyId) headers['agency-id'] = agencyId;
    if (withJson) headers['Content-Type'] = 'application/json';
    return headers;
};

const handleV3ApiFailure = (error) => {
    const status = error?.response?.status;
    if (status === 401) {
        if (typeof window !== 'undefined') {
            window.location.assign('/login');
        }
    }
    throw error;
};

const requestEvTariffsWithRetry = async (requestFn) => {
    try {
        const payload = await requestFn();
        return assertV3EnvelopeOk(payload);
    } catch (error) {
        if (error?.response?.status === 502) {
            try {
                const payload = await requestFn();
                return assertV3EnvelopeOk(payload);
            } catch (retryError) {
                return handleV3ApiFailure(retryError);
            }
        }
        return handleV3ApiFailure(error);
    }
};

/** gRPC gateway often returns HTTP 200 with { status: 4xx } in the JSON body */
const assertV3EnvelopeOk = (payload) => {
    if (!payload || typeof payload !== 'object') return payload;
    const envelopeStatus = payload.status;
    if (envelopeStatus === undefined) return payload;
    if (envelopeStatus >= 200 && envelopeStatus < 300) return payload;
    const err = new Error(
        payload?.error?.message || payload?.message || 'Request failed',
    );
    err.response = { data: payload, status: envelopeStatus };
    throw err;
};

// GET /v3/evTariffs?current=true — one row per tariff code (effectiveTo null)
export const APIGetCurrentEvTariffs = (token, agencyId) => requestEvTariffsWithRetry(async () => {
    const response = await axios.get(`${urlV3}/evTariffs`, {
        headers: buildV3AuthHeaders(token, agencyId),
        params: { current: true },
    });
    return response.data;
});

// GET /v3/evTariffs?status=ACTIVE — all active rows (default table uses one current row per code)
export const APIGetActiveEvTariffs = (token, agencyId) => requestEvTariffsWithRetry(async () => {
    const response = await axios.get(`${urlV3}/evTariffs`, {
        headers: buildV3AuthHeaders(token, agencyId),
        params: { status: 'ACTIVE', sort: '-effectiveFrom', limit: 500 },
    });
    return response.data;
});

// GET /v3/evTariffs?tariff=X&date_start=...&date_end=...&sort=-effectiveFrom&limit=500
export const APIGetEvTariffHistory = (token, agencyId, {
    tariff,
    dateStart,
    dateEnd,
    limit = 500,
    sort = '-effectiveFrom',
} = {}) => {
    const params = { sort, limit };
    if (tariff) params.tariff = tariff;
    if (dateStart) params.date_start = dateStart;
    if (dateEnd) params.date_end = dateEnd;
    return requestEvTariffsWithRetry(async () => {
        const response = await axios.get(`${urlV3}/evTariffs`, {
            headers: buildV3AuthHeaders(token, agencyId),
            params,
        });
        return response.data;
    });
};

// POST /v3/evTariffs
export const APICreateEvTariff = (token, agencyId, body) => requestEvTariffsWithRetry(async () => {
    const response = await axios.post(`${urlV3}/evTariffs`, body, {
        headers: buildV3AuthHeaders(token, agencyId, true),
    });
    return response.data;
});

// PUT /v3/evTariffs/:id
export const APIUpdateEvTariff = (token, agencyId, id, body) => requestEvTariffsWithRetry(async () => {
    const response = await axios.put(`${urlV3}/evTariffs/${encodeURIComponent(id)}`, body, {
        headers: buildV3AuthHeaders(token, agencyId, true),
    });
    return response.data;
});

// DELETE /v3/evTariffs/:id (archive)
export const APIArchiveEvTariff = (token, agencyId, id) => requestEvTariffsWithRetry(async () => {
    const response = await axios.delete(`${urlV3}/evTariffs/${encodeURIComponent(id)}`, {
        headers: buildV3AuthHeaders(token, agencyId),
    });
    return response.data;
});

export const APIGetMaintenanceRecordsByAssetId = async (setLoading, token, agencyId, assetId) => {
    setLoading(true);
    const headers = {
        Authorization: token,
        'agency-id': agencyId,
    };

    const candidateRequests = [
        () => axios.get(`${urlV3}/maintenance/asset/${assetId}`, { headers }),
        () => axios.get(`${urlV3}/maintenance/assetId/${assetId}`, { headers }),
        () => axios.get(`${urlV3}/maintenance/asset-id/${assetId}`, { headers }),
        () => axios.get(`${urlV3}/maintenanceRecord/asset/${assetId}`, { headers }),
        () => axios.get(`${urlV3}/maintenanceRecord/assetId/${assetId}`, { headers }),
        () => axios.get(`${urlV3}/maintenanceRecord/asset-id/${assetId}`, { headers }),
        () => axios.get(`${urlV3}/maintenance`, {
            headers,
            params: { assetId: assetId },
        }),
    ];

    let lastError = null;
    for (let i = 0; i < candidateRequests.length; i += 1) {
        try {
            // eslint-disable-next-line no-await-in-loop
            const result = await candidateRequests[i]();
            return result;
        } catch (error) {
            lastError = error;
            const status = error?.response?.status;
            if (status && status !== 404) {
                throw error;
            }
        }
    }

    throw lastError || new Error('Unable to fetch maintenance records by asset id');
};

/** Same as APIGetMaintenanceRecordsByAssetId but does not toggle loading state (for background counts). */
export const APIGetMaintenanceRecordsByAssetIdQuiet = async (token, agencyId, assetId) => {
    const headers = {
        Authorization: token,
        'agency-id': agencyId,
    };

    const candidateRequests = [
        () => axios.get(`${urlV3}/maintenance/asset/${assetId}`, { headers }),
        () => axios.get(`${urlV3}/maintenance/assetId/${assetId}`, { headers }),
        () => axios.get(`${urlV3}/maintenance/asset-id/${assetId}`, { headers }),
        () => axios.get(`${urlV3}/maintenanceRecord/asset/${assetId}`, { headers }),
        () => axios.get(`${urlV3}/maintenanceRecord/assetId/${assetId}`, { headers }),
        () => axios.get(`${urlV3}/maintenanceRecord/asset-id/${assetId}`, { headers }),
        () => axios.get(`${urlV3}/maintenance`, {
            headers,
            params: { assetId: assetId },
        }),
    ];

    let lastError = null;
    for (let i = 0; i < candidateRequests.length; i += 1) {
        try {
            // eslint-disable-next-line no-await-in-loop
            const result = await candidateRequests[i]();
            return result;
        } catch (error) {
            lastError = error;
            const status = error?.response?.status;
            if (status && status !== 404) {
                throw error;
            }
        }
    }

    throw lastError || new Error('Unable to fetch maintenance records by asset id');
};

export const APIGetMaintenanceRecordsAgencyList = async (token, agencyId, params = {}) => {
    const result = await axios.get(`${urlV3}/maintenance`, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
        params,
    }).catch((error) => error);
    return result;
};

export const APIGetV3FleetSummary = async (setLoading, token, agencyId, fromTime, toTime, assetNames) => {
    setLoading(true);
    const result = await axios.get(`${urlV3}/getFleetSummary`, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
        params: {
            fromTime: fromTime,
            toTime: toTime,
            assetNames: assetNames,
        },
    });
    return result;
};
export const APIGetV3FuelManagement = async (setLoading, token, agencyId, fromTime, toTime, assetNames) => {
    setLoading(true);
    const result = await axios.get(`${urlV3}/getFuelManagement`, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
        params: {
            fromTime: fromTime,
            toTime: toTime,
            assetNames: assetNames,
        },
    });
    return result;
};

/** Classified fuel level time-series (raw + debounced + fuelStatus per sample). */
export const APIGetV3FuelLevelSignal = async (setLoading, token, agencyId, fromTime, toTime, deviceOid, fuelSource) => {
    setLoading(true);
    const result = await axios.get(`${urlV3}/getFuelLevelSignal`, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
        params: {
            fromTime,
            toTime,
            deviceOid,
            fuelSource,
        },
    }).catch((error) => error?.response || error);
    return result;
};

export const APIGetV3BatteryAnalysis = async (setLoading, token, agencyId, fromTime, toTime, assetNames) => {
    setLoading(true);
    const result = await axios.get(`${urlV3}/getBatteryAnalysis`, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
        params: {
            fromTime: fromTime,
            toTime: toTime,
            assetNames: assetNames,
        },
    });
    return result;
};

export const APIGetMaintenanceReceiptDownloadUrl = async (token, agencyId, recordId) => {
    const encodedId = encodeURIComponent(recordId);
    const result = await axios.get(`${urlV3}/maintenance/${encodedId}/attachments`, {
        headers: {
            Authorization: token,
            'agency-id': agencyId,
        },
    }).catch((error) => error);
    return result;
};

const assetComplianceHeaders = (token, agencyId) => ({
    Authorization: token,
    'agency-id': agencyId,
});

export const APIGetAssetServiceSchedule = async (setLoading, token, agencyId, assetId) => {
    setLoading(true);
    const encodedId = encodeURIComponent(assetId);
    const result = await axios.get(`${urlV3}/assets/${encodedId}/service-schedule`, {
        headers: assetComplianceHeaders(token, agencyId),
    }).catch((error) => error);
    setLoading(false);
    return result;
};

export const APIGetAssetCompliance = async (setLoading, token, agencyId, assetId) => {
    setLoading(true);
    const encodedId = encodeURIComponent(assetId);
    const result = await axios.get(`${urlV3}/assets/${encodedId}/compliance`, {
        headers: assetComplianceHeaders(token, agencyId),
    }).catch((error) => error);
    setLoading(false);
    return result;
};

/** GET /v3/assets/{assetId}/compliance/history — archived compliance records for an asset. */
export const APIGetAssetComplianceHistory = async (setLoading, token, agencyId, assetId, section) => {
    setLoading(true);
    const encodedId = encodeURIComponent(assetId);
    const params = section ? { section } : undefined;
    const result = await axios.get(`${urlV3}/assets/${encodedId}/compliance/history`, {
        headers: assetComplianceHeaders(token, agencyId),
        params,
    }).catch((error) => error);
    setLoading(false);
    return result;
};
